import { LOGO_IMAGE_HEIGHT, PROFILE_LEFT_COL_SIZE, PROFILE_RIGHT_COL_SIZE
// @ts-expect-error untyped module
} from '../../constants/ProfileConstants';
import { getIsCustomer
// @ts-expect-error untyped module
} from '../../selectors/auth';
// @ts-expect-error untyped module
import { getEditProfileLink, getFullLocationUrl } from '../../utils/urls';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { InsertImageIcon } from 'foundations-assets/icons/components/InsertImageIcon';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Big } from 'foundations-components/transitional/components/Big';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Image } from 'foundations-components/transitional/components/Image';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import styled from 'foundations-theming/utils';
import MainSection from 'marketplace-ui-common/layout/components/MainSection';
import MainSectionInner from 'marketplace-ui-common/layout/components/MainSectionInner';
import { MediaQueryView } from 'marketplace-ui-common/layout/components/MediaQueryView';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import { StorefrontHeaderView } from 'marketplace-ui-common/storefront/components/StorefrontHeaderView';
import { Fragment, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { getServices } from '../../slices/serviceCatalogSlice';
import { getMultiSelectStorefrontFilters } from '../../slices/storefrontFiltersSlice';
import { getRecentActivity } from '../../utils/homepage';
import { fromFilterStateToLocation } from '../../utils/storefrontFilters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LOGO_IMAGE_STICKY_HEIGHT = 25;
const NAV_MIN_SCREEN_SIZE = ScreenSizes.MD;
const ResponsiveMainSection = props => /*#__PURE__*/_jsx(MainSection, Object.assign({}, props, {
  responsive: true
}));
const StickyHeaderWrapper = styled(ResponsiveMainSection).withConfig({
  displayName: "ProfileHeader__StickyHeaderWrapper"
})(["position:fixed;top:0;left:", ";z-index:1211;padding-top:0;padding-bottom:0;width:", ";border-bottom:1px solid ", ";"], props => props.isInApp ? '236px' : 0, props => props.isInApp ? 'calc(100% - var(--global-nav-vertical-nav-width, 236px))' : '100%', ({
  theme
}) => theme.color['border-core-default']);
function ProfileHeader({
  activeTab,
  canonicalAppContext,
  isPrerender,
  isPreview,
  onTrackInteraction,
  profileListing,
  scrollToTabSection
}) {
  const {
    logoUrl,
    name,
    portalId: providerPortalId
  } = profileListing;
  const isCustomer = useSelector(getIsCustomer);
  const storefrontFilters = useSelector(getMultiSelectStorefrontFilters);
  const catalogServices = useSelector(getServices);
  const tabsRef = useRef(null);
  const [tabsOffsetTop, setTabsOffsetTop] = useState(null);
  const [sticky, setSticky] = useState(false);
  const history = useHistory();
  const handleTrackInteraction = useCallback((action, extras = {}) => {
    onTrackInteraction(action, Object.assign({}, extras, {
      section: 'header'
    }));
  }, [onTrackInteraction]);
  const renderedBreadcrumbs = useMemo(() => {
    const filtersLocation = fromFilterStateToLocation(storefrontFilters, catalogServices);
    const renderedBreadcrumbText = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ecosystem-marketplace-solutions-ui.profile.back"
    });
    const fromHomepage = history.location.state && 'fromHomepage' in history.location.state;
    let renderedBreadcrumbLink;
    if (isPrerender || isPreview) {
      renderedBreadcrumbLink = /*#__PURE__*/_jsx(Link, {
        disabled: isPreview,
        href: getFullLocationUrl(filtersLocation, canonicalAppContext),
        children: renderedBreadcrumbText
      });
    } else {
      const recentActivity = getRecentActivity();
      const useQuestionnaireRef = recentActivity && recentActivity.type === 'questionnaire';
      if (useQuestionnaireRef) {
        filtersLocation.search = filtersLocation.search.concat('&ref=questionnaire');
      }
      renderedBreadcrumbLink = /*#__PURE__*/_jsx(RouterLink, {
        to: fromHomepage && '/' || filtersLocation // if coming from Homepage, redirect accordingly
        ,
        onClick: () => handleTrackInteraction('click breadcrumb link'),
        children: renderedBreadcrumbText
      });
    }
    return /*#__PURE__*/_jsx(Breadcrumbs, {
      paddingInline: "0",
      marginBlockStart: "0",
      children: renderedBreadcrumbLink
    });
  }, [canonicalAppContext, catalogServices, handleTrackInteraction, history.location.state, isPrerender, isPreview, storefrontFilters]);
  const renderedEditButton = useMemo(() => {
    return !isPreview && providerPortalId === PortalIdParser.get() ? /*#__PURE__*/_jsx(Button, {
      href: getEditProfileLink(providerPortalId),
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.profile.edit"
      })
    }) : null;
  }, [isPreview, providerPortalId]);
  const handleTabClick = useCallback(tabId => {
    scrollToTabSection(tabId);
    handleTrackInteraction('click tab navigation', {
      value: tabId
    });
  }, [handleTrackInteraction, scrollToTabSection]);
  const renderedTabs = useMemo(() => {
    return /*#__PURE__*/_jsx(MediaQueryView, {
      min: NAV_MIN_SCREEN_SIZE,
      children: /*#__PURE__*/_jsxs(Tabs, {
        selected: activeTab,
        paddingBlockStart: "400",
        children: [/*#__PURE__*/_jsx(Tab, {
          tabId: "about",
          onClick: () => handleTabClick('about'),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ecosystem-marketplace-solutions-ui.profile.tabs.about"
          })
        }), /*#__PURE__*/_jsx(Tab, {
          tabId: "reviews",
          onClick: () => handleTabClick('reviews'),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ecosystem-marketplace-solutions-ui.profile.tabs.reviews"
          })
        })]
      })
    });
  }, [activeTab, handleTabClick]);
  const renderedProfileImage = useMemo(() => {
    return logoUrl ? /*#__PURE__*/_jsx(Image, {
      alt: name,
      src: logoUrl,
      objectFit: "contain",
      blockSize: sticky ? LOGO_IMAGE_STICKY_HEIGHT : LOGO_IMAGE_HEIGHT
    }) : /*#__PURE__*/_jsxs(Flex, {
      blockSize: "100%",
      flexDirection: sticky ? 'row' : 'column',
      alignItems: "center",
      justifyContent: "center",
      gap: "200",
      children: [/*#__PURE__*/_jsx(InsertImageIcon, {
        size: sticky ? '400' : '800',
        color: "icon-core-subtle"
      }), /*#__PURE__*/_jsx(Big, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.profile.logoPlaceholder"
        })
      })]
    });
  }, [logoUrl, name, sticky]);
  const scrollHandler = useCallback(() => requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      setSticky(tabsOffsetTop !== null && (isCustomer ? document.getElementsByClassName('page')[0].scrollTop : window.pageYOffset) >= tabsOffsetTop);
    });
  }), [isCustomer, tabsOffsetTop]);
  useEffect(() => {
    if (tabsRef.current) {
      const {
        top: tabsTop
      } = tabsRef.current.getBoundingClientRect();
      setTabsOffsetTop(tabsTop + (isCustomer ? document.getElementsByClassName('page')[0].scrollTop : window.pageYOffset));
    }
  }, [isCustomer, tabsRef]);
  useEffect(() => {
    scrollHandler();
    window.addEventListener('scroll', scrollHandler, true);
    return () => window.removeEventListener('scroll', scrollHandler, true);
  }, [scrollHandler]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      borderBlockEndColor: "border-core-default",
      borderBlockEndStyle: "solid",
      borderBlockEndWidth: "100",
      children: /*#__PURE__*/_jsx(StorefrontHeaderView, {
        backgroundImage: "none",
        color: "white",
        children: /*#__PURE__*/_jsx(View, {
          paddingBlockStart: "400",
          paddingBlockEnd: "1500",
          children: /*#__PURE__*/_jsx(MainSectionInner, {
            children: /*#__PURE__*/_jsxs(Flex, {
              justifyContent: "space-between",
              children: [renderedBreadcrumbs, renderedEditButton]
            })
          })
        })
      })
    }), /*#__PURE__*/_jsx(ResponsiveMainSection, {
      color: "light",
      position: "relative",
      marginBlockEnd: `-1400`,
      paddingBlock: "0",
      children: /*#__PURE__*/_jsx(MainSectionInner, {
        children: /*#__PURE__*/_jsxs(Grid, {
          children: [/*#__PURE__*/_jsx(GridItem, {
            size: PROFILE_LEFT_COL_SIZE,
            children: /*#__PURE__*/_jsx(View, {
              position: "relative",
              insetBlockEnd: "1200",
              children: /*#__PURE__*/_jsx(CardWrapper, {
                children: /*#__PURE__*/_jsx(Flex, {
                  alignItems: "center",
                  justifyContent: "center",
                  paddingInline: "1000",
                  paddingBlock: "400",
                  children: renderedProfileImage
                })
              })
            })
          }), /*#__PURE__*/_jsx(GridItem, {
            size: PROFILE_RIGHT_COL_SIZE,
            children: /*#__PURE__*/_jsx("div", {
              ref: tabsRef,
              children: renderedTabs
            })
          })]
        })
      })
    }), sticky && /*#__PURE__*/_jsx(MediaQueryView, {
      min: NAV_MIN_SCREEN_SIZE,
      children: /*#__PURE__*/_jsx(StickyHeaderWrapper, {
        isInApp: isCustomer,
        children: /*#__PURE__*/_jsx(MainSectionInner, {
          children: /*#__PURE__*/_jsx(Grid, {
            children: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              flex: 1,
              children: [/*#__PURE__*/_jsx(GridItem, {
                size: PROFILE_LEFT_COL_SIZE,
                children: renderedProfileImage
              }), /*#__PURE__*/_jsx(GridItem, {
                size: PROFILE_RIGHT_COL_SIZE,
                children: renderedTabs
              })]
            })
          })
        })
      })
    })]
  });
}
export default ProfileHeader;